<template>
  <div class="sd-header-wrapper" v-if="!$route.meta.noHeader">
    <announcement v-if="showAnnouncement"
      @close="showAnnouncementSetter(false)"
    />
    <div class="sd-header">
      <div class="sd-title-container">
        <div class="sd-buttons-line"
          v-if="!$route.meta.login && !$route.meta.token"
        >
          <span v-if="$route.params.key
            && ($route.meta.jira || $route.meta.confluence)"
            @click="redirectHome(routeKey)"
          >
            <a>Suche</a>
          </span>
          <span v-if="$route.params.key">
            <a class="sd-button-announcement"
              @click="showAnnouncementSetter(true)"
            >
              Ankündigung
            </a>
          </span>
          <a @click="logout()">Ausloggen</a>
          <div class="sd-user-wrapper">
            {{ userNameDisplay }}
          </div>
        </div>
        <span @click="redirectHome(routeKey)">
          <img src="/static/icon.png" height="40" width="40"/>
        </span>
        <span @click="redirectHome(routeKey)" class="sd-page-title">
          {{ pageName }}
        </span>
      </div>
    </div>
  </div>
</template>issue

<script>
import axios from 'axios';
import Announcement from './Announcement';
import mixin from '../mixins/Mixins';

export default {
  name: 'header-bar',
  mixins: [mixin],
  components: {
    Announcement,
  },

  computed: {
    showAnnouncement() {
      return this.$store.state.showAnnouncement;
    },
    routeKey() {
      if ('key' in this.$route.params &&
        typeof this.$route.params.key !== 'undefined') {
        return this.$route.params.key.toLowerCase();
      }
      return undefined;
    },
    issueKey() {
      if ('issuekey' in this.$route.params) {
        return this.$route.params.issuekey;
      }
      return undefined;
    },
    identifier() {
      if ('identifier' in this.$route.params) {
        return this.$route.params.identifier;
      }
      return undefined;
    },
    pageName() {
      if (this.$route.params.key) {
        return this.$config[this.routeKey].deskName;
      } else if (this.$route.meta.jira) {
        return `Anfrage - ${this.issueKey}`;
      } else if (this.$route.meta.confluence) {
        return 'Confluence Seite';
      } else if (this.$route.meta.login) {
        return 'geOps Support Login';
      } else if (this.$route.meta.token) {
        return 'Ticket Ansicht';
      }
      return '';
    },
    userName() {
      return this.$store.state.user.userName;
    },
    userNameDisplay() {
      if (this.routeMetaLoaded &&
        typeof this.$store.state.user.userName === 'undefined') {
        if (!this.$route.meta.token) {
          const self = this;
          axios.get('/app/get_user_name', {
            headers: {
              Pragma: 'no-cache',
              'Cache-Control': 'no-cache',
              'Content-Type': 'application/json',
            },
          }).then((response) => {
            self.$store.commit('setUserName', response.data.username);
          }).catch(() => {
            self.logout();
          });
        }
      }
      return this.userName;
    },
    routeMetaLoaded() {
      if (Object.keys(this.$route.meta).length) {
        return true;
      }
      return false;
    },
  },

  methods: {
    logout() {
      const isRouteKey = this.routeKey;
      const isissueKey = this.issueKey;
      const isidentifier = this.identifier;
      const self = this;
      axios({
        method: 'post',
        url: '/app/logout',
        headers: {
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json',
        },
      }).then(() => {
        if (isRouteKey && typeof isRouteKey !== 'undefined') {
          self.$router.push(`/${isRouteKey}/login`);
        } else if (isissueKey && typeof isissueKey !== 'undefined') {
          self.$router.push(`/login/1/${isissueKey}`);
        } else if (isidentifier && typeof isidentifier !== 'undefined') {
          self.$router.push(`/login/2/${isidentifier}`);
        }
      }).catch((error) => {
        this.logError(error);
      });
    },

    redirectHome(routeKey) {
      if (routeKey) {
        // Force reload of the component
        if (this.$route.path === `/${routeKey}`) {
          window.history.go();
        } else {
          this.$router && this.$router.push(`/${routeKey}`);
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import "./../../Globals.scss";
.sd-header-wrapper {
  height: auto;
  min-height: 0;

  .sd-header {
    background: white;
    overflow-y: hidden;
    box-shadow: 0 3px 2px 0 rgba(0, 0, 0, 0.1);
    z-index: 99;
    position: relative;
  }

  .sd-title-container {
    max-width: $sd-max-width;
    margin: auto;
    position: relative;

    span {
      margin-left: 10px;
      float: left;
      cursor: pointer;
    }

    a {
      cursor: pointer;
      color: $sd-color-blue;
      margin: 0 0 0 15px;
    }

    img {
      padding: 10px 0 5px;
    }
  }

  .sd-page-title {
    font-weight: bold;
    font-size: 18px;
    display: inline-block;
    vertical-align: middle;
    padding-top: 24px;
    color: $sd-color-blue;
  }

  .sd-buttons-line {
    font-weight: bold;
    position: absolute;
    right: 0;
    line-height: 25px;

    a {
      opacity: 0.7;
    }

    .sd-user-wrapper {
      color: $sd-color-lightgrey;
      margin-left: 10px;
      text-align: right;
      font-weight: normal;
    }
  }
}

@media (max-width: 1100px) {
  .sd-title-container, {
    margin-left: 5%;
    margin-right: 5%;
  }

  .sd-page-title {
    font-size: 15px;
  }

  .sd-buttons-line {
    line-height: 25px;
  }
}

@media (max-width: 720px) {
  .sd-page-title {
    font-size: 13px;
  }

  .sd-title-container {
    .sd-user-wrapper {
      display: none;
    }
    a {
      font-size: 12px;
    }

    img {
      height: 30px;
      width: 30px;
    }
  }
}

@media (max-width: 350px) {
  .sd-title-container {
    a {
      font-size: 11px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Header.vue?d8825abc